import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lb-file" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上传")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload, {
      "file-list": _ctx.fileList,
      "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
      name: _ctx.name,
      action: _ctx.action,
      headers: _ctx.headers,
      onChange: _ctx.change
    }, {
      default: _withCtx(() => [
        (_ctx.fileList.length < _ctx.number)
          ? (_openBlock(), _createBlock(_component_a_button, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["file-list", "name", "action", "headers", "onChange"])
  ]))
}